import { useState, useEffect } from "react";
import { fetchLeaderboard } from "../api";

export default function Leaderboard({ refresh }) {
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    fetchLeaderboard()
      .then(res => setLeaderboard(res.data))
      .catch(err => {
        console.error("Error loading leaderboard:", err);
        alert("Failed to load leaderboard. Try again later.");
      });
  }, [refresh]);

  return (
    <div>
      <h3>Leaderboard</h3>
      <ol>
        {leaderboard.map(user => (
          <li key={user.name}>
            {user.name} - {user.totalPoints} pts (Rank #{user.rank})
          </li>
        ))}
      </ol>
    </div>
  );
}
